import { AxiosInstance } from 'axios'
import { Result } from '../../../Shared/Protocol/protocol-result'
import { IGetOrderAuditTimelinePayload, IOrderAuditTimeline } from './audit.interface'

export class AuditApiRemoteService {
  constructor(private service: AxiosInstance) {}

  public getOrderTimeline = async ({
    orderId,
    nsOrderId,
  }: IGetOrderAuditTimelinePayload): Promise<Result<IOrderAuditTimeline>> => {
    try {
      const response = await this.service.get('/audit/order/timeline', {
        params: {
          orderId,
          nsOrderId,
        },
      })

      return Result.ok(response.data)
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error)
    }
  }
}
